import React from "react";
import Header from "../components/header";
import Footer from "../components/Footer";
import "./../main.css";

function PrivacyPolicy() {
    return (
        <>
            <Header />

            <section class="author-bg" style={{ padding: '16px', marginTop: '56px' }}>
                <div class="author-inner" style={{ textAlign: 'center' }}>
                    <h2 class="author-name" style={{ margin: '15px' }}>Privacy Policy</h2>
                </div>
            </section>

            <section className="hero privacy-policy" style={{ textAlign: 'left' }}>
                <div className="privacy-container">
                    <p>
                        Free State Solution LLC (DeSantis 1776.com) respects your privacy and is
                        committed to protecting your personal information.
                    </p>

                    <h2>Information We Collect</h2>
                    <p>When you place an order or interact with our Website, we may collect:</p>

                    <ul>
                        <li>Name</li>
                        <li>Email address</li>
                        <li>Billing address</li>
                        <li>Shipping address</li>
                        <li>Phone number</li>
                        <li>
                            Payment information processed through our third-party payment processor
                        </li>
                    </ul>

                    <h2>How We Use Your Information</h2>
                    <p>We use the information we collect to:</p>

                    <ul>
                        <li>Process and fulfill orders;</li>
                        <li>Communicate with customers regarding purchases and shipping;</li>
                        <li>Respond to customer service inquiries;</li>
                        <li>Improve the functionality and security of our Website;</li>
                        <li>Comply with legal obligations.</li>
                    </ul>

                    <h2>Payment Processing</h2>
                    <p>
                        Payments are processed securely through third-party payment processors. We
                        do not store complete credit card or debit card information on our servers.
                    </p>

                    <h2>Sharing of Information</h2>
                    <p>
                        We may share information with trusted third parties who assist in operating
                        our business, including payment processors, shipping carriers, and service
                        providers, as necessary to fulfill orders and operate the Website.
                    </p>

                    <h2>Data Security</h2>
                    <p>
                        We take reasonable measures to protect the personal information submitted to
                        us. However, no method of electronic transmission or storage is completely
                        secure, and we cannot guarantee absolute security.
                    </p>

                    <h2>Changes to This Privacy Policy</h2>
                    <p>
                        We reserve the right to update this Privacy Policy at any time. Any changes
                        will be posted on this page with an updated effective date.
                    </p>

                    <h2>Contact Us</h2>
                    <p>
                        Questions regarding this Privacy Policy may be directed to:
                    </p>

                    <p>
                        <strong>Free State Solution (DeSantis 1776)</strong><br />
                        Email: <a href="mailto:Orders@DeSantis1776.com" className="linkto">
                            Orders@DeSantis1776.com
                        </a>
                    </p>

                </div>
            </section>

            <Footer />
        </>
    );
}

export default PrivacyPolicy;